module.exports = __webpack_public_path__ + "static/media/firstDay2.1bc938ec.jpg";